import { StaticJsonRpcProvider } from '@ethersproject/providers'

export const getProvider = new StaticJsonRpcProvider("https://goerli.base.org")
